export default __webpack_public_path__ + "static/media/overview.e31a9043.svg";